import { marked } from 'marked';
import DOMPurify from 'dompurify';
import TurndownService from 'turndown';

const BARE_URL = /https?:\/\/[^\s<]+/gu;
const BACKSLASH = /\\/gu;

const turndown = (() => {
  const service = new TurndownService({
    headingStyle: 'atx',
    codeBlockStyle: 'fenced',
    bulletListMarker: '-',
    emDelimiter: '*',
  });
  const escapeMarkdown = service.escape.bind(service);
  service.escape = (text) => escapeMarkdown(text)
    .replaceAll(BARE_URL, (url) => url.replaceAll(BACKSLASH, ''));
  service.addRule('strikethrough', {
    filter: ['del', 's', 'strike'],
    replacement: (content) => `~~${content}~~`,
  });
  service.addRule('preCodeBlock', {
    filter: 'pre',
    replacement: (_content, node) => `\n\n\`\`\`\n${node.textContent}\n\`\`\`\n\n`,
  });
  return service;
})();

export const htmlToMarkdown = (root) => turndown.turndown(root);

export const markdownToHtml = (markdown) => (
  DOMPurify.sanitize(marked.parse(markdown ?? '', { gfm: true, breaks: true }))
);
